import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {BrowserRouter} from 'react-router-dom';
import styles from 'css/app.css';
import Router from 'js/router';
import Header from 'js/components/header';
import BreadCrumbs from 'js/components/breadcrumbs';
import Footer from 'js/components/footer';
import ScrollTop from 'js/components/scroll-top';
import Modal from 'js/components/modal';
import {PageLoader, ActionLoader} from 'js/components/loader';
import {AppStore} from 'js/stores';

@observer
/**
 * App
 */
export default class App extends Component {
  /**
   * constructor
   */
  constructor() {
    super();

    this.clearError = this.clearError.bind(this);
  }

  /**
   * will moount
   */
  componentWillMount() {
    // 初期処理
    AppStore.init();
  }

  /**
   * clear error
   */
  clearError() {
    AppStore.clearError(false);
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const view = (AppStore.ready.db && AppStore.ready.page ? true : false);
    const actionView = (AppStore.ready.action ? true : false);

    return (
      <BrowserRouter>
        <div className={styles.frame}>
          <Header />
          <BreadCrumbs />
          <Router />
          <PageLoader view={view} />
          <ActionLoader view={actionView} />
          <Footer />
          <ScrollTop />
          {AppStore.error && (
            <Modal close={this.clearError}>
              システムエラーが発生しました。
            </Modal>
          )}
        </div>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/app.js